var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconAssign = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-98.5,12a1,1,0,0,1-1,1,1,1,0,0,1-1-1,1,1,0,0,1,1-1A1,1,0,0,1-98.5,12ZM-88,5.946a1,1,0,0,0-1.351-.417,1,1,0,0,0-.418,1.351A10.862,10.862,0,0,1-88.5,12a10.862,10.862,0,0,1-1.269,5.12,1,1,0,0,0,.418,1.352,1,1,0,0,0,.466.115A1,1,0,0,0-88,18.054,13.029,13.029,0,0,0-86.5,12,13.032,13.032,0,0,0-88,5.946Zm-4.889,1.445a1,1,0,0,0-.418,1.351A6.912,6.912,0,0,1-92.5,12a6.9,6.9,0,0,1-.808,3.258,1,1,0,0,0,.419,1.351.989.989,0,0,0,.465.116,1,1,0,0,0,.886-.534A9.027,9.027,0,0,0-90.5,12a9.01,9.01,0,0,0-1.039-4.191A1,1,0,0,0-92.889,7.391Zm-3.554,1.87a1,1,0,0,0-.417,1.351A2.958,2.958,0,0,1-96.5,12a2.958,2.958,0,0,1-.36,1.388,1,1,0,0,0,.417,1.351,1,1,0,0,0,.466.115,1,1,0,0,0,.885-.533A4.925,4.925,0,0,0-94.5,12a4.925,4.925,0,0,0-.592-2.321A1,1,0,0,0-96.443,9.261Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAssign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-assign.237f372d.svg";
export { ForwardRef as ReactComponent };